import { CommonConfig, GraftResolutionMode, CommonDataOrName, CommonRestProperties } from "./commonConfig";
import { CommonAction } from "./commonAction";
import { Operations } from "../material-ui/NavigatorData";

export class GraftConfig extends CommonConfig implements GraftRestProperties {
    public graftResolutionMode = GraftResolutionMode.changesetPriority;
    restNames = new GraftRestPropertyNames();

    constructor(aFile: File | any, bFile: File | any) {
      super();
      this.changeSet = CommonAction.convertToBlobIfString(aFile);
      this.target = CommonAction.convertToBlobIfString(bFile);
    }
}

interface GraftDataOrName extends CommonDataOrName {
  graftResolutionMode: GraftResolutionMode | string;
}

class GraftRestProperties extends CommonRestProperties implements GraftDataOrName{
  graftResolutionMode!: GraftResolutionMode;
}

export class GraftRestPropertyNames implements GraftDataOrName {
  public readonly graftResolutionMode = "graftResolutionMode";
  public readonly changeSet = "changeset";
  public readonly target = "target";
  public readonly jobLabel = "jobDescriptor";
  public readonly resultFilename = "resultFilename";
}

export class GraftAction extends CommonAction {

  constructor(baseURL: string) {
    super(baseURL, "graft", Operations.graft);
  }

  public graft = this.action;
}